'use strict';

var Actor = require('../util/actor');
var WorkerTile = require('./worker_tile');
var util = require('../util/util');
var ajax = require('../util/ajax');
var vt = require('vector-tile');
var Protobuf = require('pbf');

var geojsonvt = require('geojson-vt');
var GeoJSONWrapper = require('./geojson_wrapper');

module.exports = function(self) {
    return new Worker(self);
};

function Worker(self) {
    this.self = self;
    this.actor = new Actor(self, this);
    this.loading = {};

    this.loaded = {};
    this.layers = [];
    this.geoJSONIndexes = {};
}

util.extend(Worker.prototype, {
    'set layers': function(layers) {
        this.layers = layers;
    },

    'load tile': function(params, callback) {
        var source = params.source,
            uid = params.uid;

        if (!this.loading[source])
            this.loading[source] = {};


        var tile = this.loading[source][uid] = new WorkerTile(params);

        tile.xhr = ajax.getArrayBuffer(params.url, done.bind(this));

        function done(err, data) {
            delete this.loading[source][uid];

            if (err) return callback(err);
            
            //RWM: note, tile is a workertile, but tile.data is a vectortile
            tile.data = new vt.VectorTile(new Protobuf(new Uint8Array(data)));
            //RWM: add in the join data from params:
            //TODO: here
            if (tile.join.enabled) {
                //console.log("tile.data: ", tile.data);
                var sourceLayer = tile.join['source-layer'];
                if (tile.data.layers[sourceLayer]) {
                    var numKeys = tile.data.layers[sourceLayer]._keys.length;
                    var areakeyidx = -1, datafieldidx = -1;
                    for (var i = 0; i < numKeys; i++) {
                        if (tile.data.layers[sourceLayer]._keys[i] == tile.join.areakey) {
                            areakeyidx = i;
                        }
                        //NOTE: areakey and datafield could be equal (weird)
                        if (tile.data.layers[sourceLayer]._keys[i] == tile.join.datafield) {
                            datafieldidx = i;
                        }
                        if ((areakeyidx >= 0) && (datafieldidx >= 0)) break;
                    }
                    
                    if ((areakeyidx != -1) && (datafieldidx != -1)) {
                        for (var i = 0; i < tile.data.layers[sourceLayer]._values.length; i += numKeys) {
                            //tile.data.layers[sourceLayer]._values[i + datafieldidx] = 1.0;
                            var ak = tile.data.layers[sourceLayer]._values[i + areakeyidx];
                            if (tile.join.data.hasOwnProperty(ak))
                                tile.data.layers[sourceLayer]._values[i + datafieldidx] = tile.join.data[ak];
                            else
                                tile.data.layers[sourceLayer]._values[i + datafieldidx] = 0;
                            //else - error, no value to join with - default value? at the moment I'm just leaving it as it was
                        }
                    }
                    else {
                        //error, one or other not found
                        if (areakeyidx == -1) { console.log("BAD AREA KEY ON JOIN: join.areakey=" + tile.join.areakey, "Fields: ", tile.data.layers[sourceLayer]._keys); }
                        if (datafieldidx == -1) { console.log("BAD DATA FIELD ON JOIN: join.datafield=" + tile.join.datafield, "Fields: ", tile.data.layers[sourceLayer]._keys); }
                    }
                }
            }
            tile.parse(tile.data, this.layers, this.actor, callback);

            this.loaded[source] = this.loaded[source] || {};
            this.loaded[source][uid] = tile;
        }
    },

    'reload tile': function (params, callback) {
        var loaded = this.loaded[params.source],
            uid = params.uid;
        if (loaded && loaded[uid]) {
            var tile = loaded[uid];
            tile.parse(tile.data, this.layers, this.actor, callback);
        }
    },

    'abort tile': function(params) {
        var loading = this.loading[params.source],
            uid = params.uid;
        if (loading && loading[uid]) {
            loading[uid].xhr.abort();
            delete loading[uid];
        }
    },

    'remove tile': function(params) {
        var loaded = this.loaded[params.source],
            uid = params.uid;
        if (loaded && loaded[uid]) {
            delete loaded[uid];
        }
    },

    'redo placement': function(params, callback) {
        var loaded = this.loaded[params.source],
            loading = this.loading[params.source],
            uid = params.uid;

        if (loaded && loaded[uid]) {
            var tile = loaded[uid];
            var result = tile.redoPlacement(params.angle, params.pitch, params.collisionDebug);

            if (result.result) {
                callback(null, result.result, result.transferables);
            }

        } else if (loading && loading[uid]) {
            loading[uid].angle = params.angle;
        }
    },

    'parse geojson': function(params, callback) {
        var indexData = function(err, data) {
            if (err) return callback(err);
            this.geoJSONIndexes[params.source] = geojsonvt(data, params.geojsonVtOptions);
            callback(null);
        }.bind(this);

        // TODO accept params.url for urls instead

        // Not, because of same origin issues, urls must either include an
        // explicit origin or absolute path.
        // ie: /foo/bar.json or http://example.com/bar.json
        // but not ../foo/bar.json
        if (typeof params.data === 'string') {
            ajax.getJSON(params.data, indexData);
        }
        else indexData(null, params.data);
    },

    'load geojson tile': function(params, callback) {
        var source = params.source,
            coord = params.coord;

        // console.time('tile ' + coord.z + ' ' + coord.x + ' ' + coord.y);

        var geoJSONTile = this.geoJSONIndexes[source].getTile(coord.z, coord.x, coord.y);

        // console.timeEnd('tile ' + coord.z + ' ' + coord.x + ' ' + coord.y);

        // if (!geoJSONTile) console.log('not found', this.geoJSONIndexes[source], coord);

        if (!geoJSONTile) return callback(null, null); // nothing in the given tile

        var tile = new WorkerTile(params);
        tile.parse(new GeoJSONWrapper(geoJSONTile.features), this.layers, this.actor, callback);

        this.loaded[source] = this.loaded[source] || {};
        this.loaded[source][params.uid] = tile;
    },

    'query features': function(params, callback) {
        var tile = this.loaded[params.source] && this.loaded[params.source][params.uid];
        if (tile) {
            tile.featureTree.query(params, callback);
        } else {
            callback(null, []);
        }
    },

    /////RWM
    'set features': function (params, callback) {
        console.log("IN SET FEATURES");
        console.log("params: ", params);
        var tile = this.loaded[params.source] && this.loaded[params.source][params.uid];
        if (tile) {
            console.log("tile: ", tile);
            console.log("tile.data: ", tile.data); //this is a vector tile
            //console.log("featuretree: ", tile.featureTree);
            //var all = tile.featureTree.rtree.all();
            //console.log("rtree all: ", all);
            //todo: check the feature.layer=prototiles10 as well?
            //for (var i = 0; i < all.length; i++) {
            //    //console.log("all feature", all[i].feature);
            //    all[i].feature.properties.value = 0;
            //}
            //bucket.prototype.addFeatures();
            console.log("parse data: ", tile.data, this.layers, this.actor, callback);
            //hack - zero the value attribute
            for (var i = 0; i < tile.data.layers.mytilepoints._values.length; i+=5) {
                if (i + 4 < tile.data.layers.mytilepoints._values.length) { tile.data.layers.mytilepoints._values[i + 4] = 0; }
            }
            tile.parse(tile.data, this.layers, this.actor, /*callback*/ function () { });
            //tile.unloadVectorData(this.map.painter);
            //tile.loadVectorData(tile.data);
        }
        //params.source._renderTiles(params.layers, params.map.painter);
        //params.source.reload();
        //tilepyramid.reload(); ???
        //params.source._pyramid.reload();

    }

    /////END RWM
});
